import type { DripWorkflowNodeKind } from './dripWorkflowKinds.js';

/** Grouped chips — drag into the workflow to add a step of this `kind`. */
export const DRIP_WORKFLOW_PALETTE_SECTIONS: {
  id: string;
  heading: string;
  items: {
    kind: DripWorkflowNodeKind;
    paletteLabel: string;
    title: string;
    subtitle: string;
  }[];
}[] = [
  {
    id: 'communication',
    heading: 'Communication',
    items: [
      { kind: 'email', paletteLabel: 'Email', title: 'Email', subtitle: 'Send an email' },
      { kind: 'sms', paletteLabel: 'SMS', title: 'SMS', subtitle: 'Text message' },
      { kind: 'call', paletteLabel: 'Call', title: 'Call', subtitle: 'Phone touchpoint' },
    ],
  },
  {
    id: 'social',
    heading: 'Social Media',
    items: [
      { kind: 'instagram', paletteLabel: 'Instagram', title: 'Instagram', subtitle: 'Social touchpoint — Instagram' },
      { kind: 'facebook', paletteLabel: 'Facebook', title: 'Facebook', subtitle: 'Social touchpoint — Facebook' },
      { kind: 'twitter', paletteLabel: 'X (Twitter)', title: 'X (Twitter)', subtitle: 'Social touchpoint — X' },
    ],
  },
  {
    id: 'workflow',
    heading: 'Workflow',
    items: [
      { kind: 'wait', paletteLabel: 'Wait', title: 'Wait', subtitle: 'Pause before the next step' },
      { kind: 'condition', paletteLabel: 'Condition', title: 'Condition', subtitle: 'Branch on rules' },
    ],
  },
  {
    id: 'crm',
    heading: 'CRM',
    items: [
      { kind: 'task', paletteLabel: 'Task', title: 'Task', subtitle: 'Create or complete a CRM task' },
      { kind: 'tag', paletteLabel: 'Tag', title: 'Tag', subtitle: 'Apply or remove a tag' },
    ],
  },
  {
    id: 'events',
    heading: 'Events',
    items: [
      {
        kind: 'event_reminder',
        paletteLabel: 'Event reminder',
        title: 'Event reminder',
        subtitle: 'Notify before the event',
      },
      {
        kind: 'confirm_attendance',
        paletteLabel: 'Confirm attendance',
        title: 'Confirm attendance',
        subtitle: 'RSVP or attendance confirmation',
      },
    ],
  },
  {
    id: 'integrations',
    heading: 'Integrations',
    items: [{ kind: 'webhook', paletteLabel: 'Webhook', title: 'Webhook', subtitle: 'POST to an external URL' }],
  },
];
